import React, { useEffect, useState } from 'react'
import { Button, Col, Input, Progress, Row } from 'reactstrap'
import InfoPopup from './InfoPopup';
import BannerRibbon from './BannerRibbon';
import moment from 'moment';
import firstFoldconstants from '../../constants/firstFoldconstants';
import Gift from '../assets/svgs/Gift';
import VideoModal from './VideoModal';
import { Modal,ModalHeader,ModalBody } from 'reactstrap';
import { submitIntent } from '../services/waitlist-service';
import { toast } from 'react-toastify';
import { utils } from '../../core/helpers/utils';

const FirstFold = (props) => {
    const [showPopUpText, setShowPopupText] = useState(false);
    const [popUpOverText, setPopUpOverText] = useState("");
    const [preBookText, setPreBookText] = useState(true);
    const soldOut = props?.mldAssetDetails?.soldOutTxt ? props.mldAssetDetails.soldOutTxt : "0";
    const { units, increaseUnits, decreaseUnits, setUnitsFunc, goToPaymentOverview, toggleEstimatePopup } = props;
    const [showPopUpHead, setShowPopUpHead] = useState(false);
    const [learnVideoSrc, setLearnVideoSrc] = useState("");
    const [showVideo, setShowVideo] = useState(false);
    const [disableInvestButton, setDisableInvestButton] = useState(false);
    const popUpInfoHead = 'A Nifty 50 linked - Market Linked Debenture (MLD), with 100% Principal Protection and Minimum Assured Returns of 14% on Maturity'
    
    const progressStyle = {
        height: '1.25rem',
        fontWeight: '800',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: "10px",
        borderBottomRightRadius: "10px",
        borderBottomLeftRadius: "10px",
    }

    const barStyle = {
        borderRadius: '10px',
        color: "black",
    }

    const soldOutText = {
        fontSize: "12px",
        color: "black",
        marginTop: "-19px",
        fontWeight: "bold",
        marginBottom: "0"
    }

    const handleInfoClick = (item, key) => {
        if (key || key === 0) {
            setPopUpOverText(item);
            setShowPopupText(!showPopUpText);
        }
    }

    const handleReferralClick = (text) => {
        setPopUpOverText(text);
        setShowPopupText(!showPopUpText);
    }

    const toggleInfoPopup = () => {
        setShowPopupText(!showPopUpText);
    }

    const redirectToMld = () => {
        window.open(process.env.REACT_APP_BASE_URL_BONDS + "/market-linked-debentures/mld3/details", "_blank", "noopener");
    }

    const handleWebinar = () => {
        window.open(firstFoldconstants.video.url1, "_blank", "noopener");
    }
    const intentNow = async () => {
        try { 
            let payload = utils.getPKey() ? {
                payload: utils.encryptedPayload({
                    "units": props?.mldAssetDetails?.minUnits,
                    "amount": props?.priceResponse?.userAmount,
                    "status": true,
                    "productType": props?.mldAssetDetails?.productType
                })
            } : {
                "units": props?.mldAssetDetails?.minUnits,
                "amount": props?.priceResponse?.userAmount,
                "status": true,
                "productType": props?.mldAssetDetails?.productType
            };
    
          const headers = { "X-product": `orobonds:default` };
    
          const result1 = await submitIntent(props?.mldAssetDetails?.ISIN ,headers, payload);
          const result = utils.parsePayload(result1);

          result?.message && toast.success(result?.message)
        } catch (e) {
          toast.error('Something went wrong : ', e);
        }
      }
    

    const handleBenifitClick = () => {
        let text;
        if (props?.priceResponse?.referralBenefits?.isSpecialBenefitUser) {
            text = "<p><b>Offer Benefit: </b>"
                + props?.priceResponse?.referralBenefits?.perTxnRefereralSpecialBenefitLimit * 100
                + "% returns applied as benefit since you are eligible for the Special Offer. T&C Apply.</p>"
        } else if (!props?.priceResponse?.referralBenefits?.isSpecialBenefitUser) {
            text = "<p><b>Offer Benefit: </b>"
                + props?.priceResponse?.referralBenefits?.perTxnRefereralBenefitLimit * 100
                + "% returns applied as benefit since you are eligible for the Special Offer. T&C Apply.</p>"
        }
        setPopUpOverText(text);
        setShowPopupText(!showPopUpText);
    }
    const handleCompleteNowClick = () => {
        props.toggleHvInitiateModal();
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ 
              action: "BIDD_HV", 
              data: {
                assetCode: props?.mldAssetDetails?.product,
                productType: props?.mldAssetDetails?.productType
              }
            })
          )
        } else {
          return props.hypervergeVerification();
        }
      }

    useEffect(() => {
        const currentTime = moment();

        // Removed weekend check
        // if (currentTime.day() === 0 || currentTime.day() === 6) {
        //     setPreBookText(true);
        // }
        
        if (currentTime.isBefore(moment(props?.mldAssetDetails?.openDate))) {
            setPreBookText(true);
        } else if (currentTime.isAfter(moment(props?.mldAssetDetails?.openDate))) {
            // check market hours
            if (currentTime.isBefore(moment(props?.mldAssetDetails?.marketStartTime, "HH:mm")) ||
                currentTime.isAfter(moment(props?.mldAssetDetails?.marketEndTime, "HH:mm"))) {
                /** 
                 * outside market hours order to set as prebook.
                 * there is a script to fetch all ipo-prebooks orders and
                 * place them on the exchange
                */
                setPreBookText(true);
            } else {
                setPreBookText(false);
            }
        }

        let closeDateTime = moment(props?.mldAssetDetails?.closeDate).format("DD/MM/YYYY");
        closeDateTime += `${props?.mldAssetDetails?.marketEndTime}`;
        closeDateTime = moment(closeDateTime, "DD/MM/YYYYhh:mm");

        if (currentTime.isAfter(closeDateTime)) {
            setPreBookText(true)
        }
    }, [props.mldAssetDetails])

    const getButtonText = () => {
        let hvCug = props?.thirdPartyData.userInHypervergeCug;
        let enhancedStatus = props?.thirdPartyData.enhancedKycStaus;
        let icmApproved = !props.errors?.length && props?.userState?.obUserApproved;
    
        if (hvCug) {
          if(enhancedStatus === "approved"){
            return "Invest Now"
          }
          if (enhancedStatus === "underProcess") {
            return "KYC Under Process"
          }
          if ((enhancedStatus === "pending" || enhancedStatus === 'retry') && !icmApproved) {
            return "Get Started"
          }
          if ((enhancedStatus === "pending" || enhancedStatus === 'retry') && icmApproved) {
            return "Invest Now"
          }
          if (!icmApproved && (enhancedStatus === "pending" || enhancedStatus === 'retry')) {
            return "Get Started"
          }if(enhancedStatus === "rejected"){
            return "Re-initiate KYC"
          }
        } else if (!hvCug) {
          if (props?.isNewJourney) {
            return "Get Started"
          }
          if (props?.errors?.length) {
            return "Re-initiate KYC"
          } 
          if (icmApproved) {
            return "Invest Now"
          }
          if (!props?.isKycDone && !props.errors.length) {
            return "KYC Under Process"
          }
        } else {
          return "KYC Pending"
        }
      }

    useEffect(() => {
        const currentTime = moment();
        if (currentTime.day() == 0 || currentTime.day() == 6) {
            setPreBookText(true);
        }
        if (currentTime.isBefore(moment(props?.mldAssetDetails?.openDate))) {
            setPreBookText(true);
        } else if (currentTime.isAfter(moment(props?.mldAssetDetails?.openDate))) {
            // check market hours
            if (currentTime.isBefore(moment(props?.mldAssetDetails?.marketStartTime, "HH:mm")) ||
                currentTime.isAfter(moment(props?.mldAssetDetails?.marketEndTime, "HH:mm"))) {
                /** 
                 * outside market hours order to set as prebook.
                 * there is a script to fetch all ipo-prebooks orders and
                 * place them on the exchange
                */
                setPreBookText(true);
            } else {
                setPreBookText(false);
            }
        }

        let closeDateTime = moment(props?.mldAssetDetails?.closeDate).format("DD/MM/YYYY");
        closeDateTime += `${props?.mldAssetDetails?.marketEndTime}`;
        closeDateTime = moment(closeDateTime, "DD/MM/YYYYhh:mm");

        if (currentTime.isAfter(closeDateTime)) {
            setPreBookText(true)
        }
    }, [props.mldAssetDetails])

    const handleHeadInfoClick = () => {
        setShowPopUpHead(!showPopUpHead)
    }

    const openInvestorPdf = () => {
        window.open(firstFoldconstants.pdf.pdf1, "_blank");
    }

    const handlelearnCLick = (src) => {
        setLearnVideoSrc(src);
        toggleVideoModal();
    }

    const toggleVideoModal = () => {
        setShowVideo(!showVideo);
    }

    useEffect(() => {
        let isNewJourney = props?.isNewJourney;
        let isError = props?.errors?.length;
        let isTxnAllowed = props?.mldAssetDetails?.enableInvestButton;
        let isKYCed = props?.userState?.obUserApproved;
        // if new journey or there is error or is not KYCed, enable button
        if(props?.thirdPartyData.enhancedKycStaus === "underProcess"){
            return setDisableInvestButton(true);
          }
          if (isNewJourney || isError) {
            return setDisableInvestButton(false);
          }
          if(!props?.userState?.obUserApproved){
            return setDisableInvestButton(true)
          }
          if(props?.assetDetails?.userInRfqCug || props?.assetDetails?.enableInvestButton){
            return setDisableInvestButton(false);
          }
          // CUG is handled in backend
          if (isTxnAllowed) {
            return setDisableInvestButton(false);
          }
          return setDisableInvestButton(true);
    }, [props])

    return (
        <>
            
            <Row className="mld-first-fold" style={(!props?.isUserInvested && !props?.isMobile) ? { marginTop: "3rem" } : {}}>
                <Col lg={7} className='col-first'>
                    {!props?.isMobile ?
                        <div className='logo-title'>
                            <div className='logo'>
                                <img src={props?.mldAssetDetails?.logoUrl} alt="logourl" className='logo-img'/>
                            </div>
                            <div className='title-subtitle'>
                                <p className='title mb-1'>
                                    {props?.mldAssetDetails?.productName}
                                    {/* <span
                                        onClick={handleHeadInfoClick}
                                        className="mdi mdi-information-outline ml-2"
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "15px",
                                        }}
                                    /> */}
                                </p>
                                <p className='subtext'>{props?.mldAssetDetails?.tagLine}</p>
                            </div>
                        </div>
                    :
                    <div className='title-subtitle'>
                        <p className='title mb-1'>
                            {props?.mldAssetDetails?.productName}
                            {/* <span
                                onClick={handleHeadInfoClick}
                                className="mdi mdi-information-outline ml-2"
                                style={{
                                    cursor: "pointer",
                                    fontSize: "15px",
                                }}
                            /> */}
                        </p>
                        <p className='subtext'>{props?.mldAssetDetails?.tagLine}</p>
                    </div>
                    }
                    <div className='ribbon-main'>
                        {props?.mldAssetDetails && props?.mldAssetDetails?.highlights &&
                            props?.mldAssetDetails?.highlights.length ?
                            props?.mldAssetDetails?.highlights.map(item => (
                                <BannerRibbon text={item.text} popup={item.popup} mldAssetDetails={props.mldAssetDetails}/>
                            )) : null}
                    </div>
                    {props.issueList && props.issueList.length && <div className='points'>
                        {props.issueList?.map((item, key) => (
                            <div className='cards'>
                                <p className='first-text text-muted'>{item.point}
                                    {item.infoic &&
                                        <span
                                            onClick={() => handleInfoClick(item.popOvertext, key)}
                                            className="mdi mdi-information-outline ml-2"
                                            style={{
                                                cursor: "pointer",
                                                fontSize: "15px",
                                            }}
                                        />
                                    }
                                </p>
                                <p
                                    className='second-text'
                                    dangerouslySetInnerHTML={{ __html: item.explaination }}
                                />
                                {item.learnMore ? <p onClick={() => handlelearnCLick(item.learnVideoSrc)} className='learnmore'>Learn more about {item.point} <span class="mdi mdi-play-circle"></span></p> : null}
                            </div>
                        ))}
                    </div>}
                    <div className='btn-holder'>

                        {/* {props.mldAssetDetails.bondId === "mld4" || props?.mldAssetDetails?.bondId === "gmldm0" || props?.mldAssetDetails?.bondId === "gmld1" ? "": <Button className='btn-1' outline onClick={redirectToMld}>Learn About MLDs</Button>} */}
                        {/* <Button  onClick={handleWebinar}className='btn-2'outline  ><span class="mdi mdi-play-circle"></span>View Webinar</Button> */}
                        {props?.mldAssetDetails?.bondId === "mld3" ? <Button className='btn-3' outline onClick={openInvestorPdf}>MLD Presentation</Button> : null}
                    </div>
                </Col>

                {props.mldAssetDetails && !props.mldAssetDetails.isProductAvailable ? 
                 (
                    <div className="col-lg-5 asset-table pos-fixed">
                      <div className="asset-content">
                        <div className={`asset-body d-flex flex-column ${!props.mldAssetDetails?.isProductAvailable ? "top-border" : ""}`}>
                          <div className="assetContainerIntent">
                            <p className="sharesNote">Shares coming soon!!</p>
                            <img
                              className="w-100"
                              src={`${process.env.REACT_APP_IMAGES_PATH}Notify.webp`}
                              alt="Notify"
                            />
                          </div>
                          <Button onClick={intentNow} className="apply-btn">
                            Notify me!
                          </Button>
                        </div>
                      </div>
                    </div>
                  )
                :
                <Col lg={5} className='col-second'>
                    <div ref={props?.investRef}></div>
                    <div className='calc-div w-100'>
                        <Progress
                            color="#EE5726"
                            value={soldOut}
                            style={progressStyle}
                            barStyle={barStyle}
                        >
                        </Progress>
                        <div className='soldout'>
                            <p style={soldOutText}>{soldOut}% Sold out</p>
                            {/* <p
                        className={
                            "font-weight-semi-bold " +
                            (!props.isMobile ? "navi-font-28 text-center mt-3" : "navi-font-24 text-center mt-3")
                        }
                    >
                        Invest Now
                    </p> */}
                            <p style={{ fontSize: "20px" }} className="font-weight-semi-bold text-center mt-4"
                            >
                                {props?.mldAssetDetails?.displayName}
                            </p>
                        </div>
                        <div className='inv-div'>
                            <div className='w-60'>
                                <p className='mb-0'>
                                    Current Price
                                    <span
                                        className="mdi mdi-information-outline ml-2"
                                        onClick={() => handleReferralClick(
                                            "Face Value : ₹1,00,000/unit"
                                        )}
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "15px",
                                        }}
                                    />
                                </p>
                            </div>
                            <div className='w-40'>
                                <p className='ml-1'>
                                    {
                                        props?.priceResponse?.Price
                                            ? "" + (props?.priceResponse?.Price)?.oroNumber(2, true) + "/unit"
                                            : " NA"
                                    }
                                </p>
                            </div>
                        </div>
                        <div className='input'>
                            <p>Enter Units</p>
                            <div className='d-flex ip'>
                                <Button onClick={decreaseUnits}>-</Button>
                                <Input
                                    style={units <= 0 ? { color: "#cfcfcf", fontSize: "12px" } : {}}
                                    value={units <= 0 ? "Enter Units" : units}
                                    onChange={(e) => setUnitsFunc(e.target.value)}
                                    pattern="[0-9]*"
                                    inputMode="numeric"
                                    placeholder="Enter Units"
                                    className="text-center"
                                />
                                <Button onClick={increaseUnits}>+</Button>
                            </div>
                        </div>
                        <div className='inv-div'>
                            <div className='w-60'>
                                <p className='mb-0'>Total Investment Amount</p>
                            </div>
                            <div className='w-40'>
                                <p className='mb-0'><b>{(props?.units >=1  && props?.priceResponse?.userAmount) ? (props.priceResponse.userAmount).oroNumber(2, true) : props?.priceResponse?.userAmount === 0 ? "₹0" : "₹0"}</b></p>
                            </div>
                        </div>
                        <div className="hr1 mb-2" />
                        {(props?.priceResponse?.referralBenefits?.discountInPercForUser > 0) ?
                            <>
                                <div className='inv-div'>
                                    <div className='w-60 d-flex'>
                                        {/* <Gift /> */}
                                        <div className='flex-column'>
                                            <p className={!props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                                ? "text-primary"
                                                : ' mb-0 text-primary'
                                            }
                                                style={{
                                                    marginTop: !props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                                        ? "10px"
                                                        : ""
                                                }}
                                            >
                                                <b style={{color:"#F15D2A"}}>Offer Benefit</b>
                                                {/* <span
                                                    className="mdi mdi-information-outline ml-2"
                                                    onClick={() => handleBenifitClick()}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontSize: "15px",
                                                        color: "black"
                                                    }}
                                                /> */}
                                            </p>
                                            <br />
                                            {/* {props?.priceResponse?.referralBenefits &&
                                                "specialBenefitExpiringInDays" in props.priceResponse.referralBenefits &&
                                                <p className='font-size-tiny mb-0' style={{ color: 'black', marginTop: '-25px' }}>
                                                    Benefit Expiring {
                                                        props?.priceResponse?.referralBenefits?.specialBenefitExpiringInDays === 0
                                                            ? "today"
                                                            : "in " + props?.priceResponse?.referralBenefits?.specialBenefitExpiringInDays + " days"
                                                    }
                                                </p>
                                            } */}
                                        </div>
                                    </div>
                                    <div className='w-40'>
                                        {props?.userState?.obUserApproved ? <p className={!props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                            ? ""
                                            : ' mb-0'
                                        }
                                            style={{
                                                marginTop: !props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                                    ? "10px"
                                                    : ""
                                            }}
                                        >
                                            <b>{
                                                props?.priceResponse?.referralBenefits?.discountInPercForUser
                                                    ? (props?.priceResponse?.referralBenefits?.discountInPercForUser).toFixed(2)+"%"
                                                    : "0%"
                                            }</b>
                                        </p> : 
                                        <p className='mb-0 mt-2'><b>Up to 0.5% Returns</b></p>
                                        }
                                    </div>
                                </div>
                                <div className="hr2 mb-4"
                                    style={{
                                        marginTop: !props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                            ? "-20px"
                                            : ""
                                    }}
                                />
                            </>
                            : null
                        }
                        {!props?.userState?.obUserApproved ?
                            <>
                                <div className='inv-div'>
                                    <div className='w-60 d-flex'>
                                        {/* <Gift /> */}
                                        <div className='flex-column'>
                                            <p className={!props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                                ? "text-primary"
                                                : ' mb-0 text-primary'
                                            }
                                                style={{
                                                    marginTop: !props?.priceResponse?.referralBenefits?.isSpecialBenefitUser
                                                        ? "10px"
                                                        : ""
                                                }}
                                            >
                                                <b style={{color:"#F15D2A"}}>Offer Benefit</b>
                                            </p>
                                        </div>
                                    </div>
                                    <div className='w-40'>
                                        <p className='mb-0 mt-2'><b>Up to 0.5% Returns</b></p>
                                    </div>
                                </div>
                                <div className="hr2 mb-4"/>
                            </>
                            : null
                        }
                        <p className='estimate' onClick={toggleEstimatePopup}>Estimate your returns</p>
                        {!preBookText ? <Button className='m-auto'
                            disabled={!units || disableInvestButton}
                            onClick={()=>goToPaymentOverview()}
                        >
                          {getButtonText()}
                        </Button> :
                            // <p>
                            //     Investment Timings <span className="font-weight-semi-bold">9am to 3:30pm, Monday - Friday </span>, Excluding Holidays
                            // </p>
                            
                            ""
                        }
                         {/* {(props?.mldAssetDetails?.product === "mld3" &&props?.mldAssetDetails?.cugMode && !props?.mldAssetDetails?.userInCug) ? 
                                <div className='disclaimer-cug'>
                                <img src = {process.env.REACT_APP_IMAGES_PATH + "calendar-icon.webp"}/>
                                <span className='text'>Investment starts on 7th Feb 2024</span>
                            </div> : null} */}
                    <Modal className="enhanced-kyc-modal" isOpen={props?.isModalOpen} zIndex={5100}>
                      <ModalHeader toggle={() => props?.toggleHvInitiateModal()} className="header">
                        {props?.isMobile? 
                        <hr onClick={() => props?.toggleHvInitiateModal()} style={{border:"1px", borderStyle:"solid", borderColor:"#898A8D", borderRadius:"10px", width:"100px", height:"5px", display:"flex", justifyContent:"center", backgroundColor:"#898A8D", cursor:"pointer"}}></hr>:null}
                      </ModalHeader>
                      <ModalBody className="body"> 
                        <p className="text">Complete your enhanced KYC to continue investing</p>
                        <div style={{display:"flex", justifyContent:"center"}}>
                          <Button className="apply-btn kyc-btn" onClick={() => handleCompleteNowClick()} >Complete Now</Button> 
                        </div>
                      </ModalBody>
                    </Modal>        
                    </div>
                </Col>}
            </Row>
            {popUpOverText &&
                <InfoPopup
                    showPopUpText={showPopUpText}
                    toggleInfoPopup={toggleInfoPopup}
                    text={popUpOverText}
                />}


            {showPopUpHead &&
                <InfoPopup
                    showPopUpText={showPopUpHead}
                    toggleInfoPopup={handleHeadInfoClick}
                    text={popUpInfoHead}
                />
            }
            <VideoModal toggleVideoModal={toggleVideoModal} showVideo={showVideo} src={learnVideoSrc} />
        </>
    )
}

export default FirstFold